import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { getFutureWeekdayExceptTodayAndTomorrow } from "src/utils/date/dateUtils";
import { formatDate } from "src/utils/string/stringUtil";

export interface KSK2010_R01Dto extends ProductOrderDto {
    
    compNm: string;
    
    orderTypeNm: string;
    
    workplaceNm: string;
    
    jobTeamNm: string;
    
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    
    orderEmpNm: string;
    
    badQty: number;
    acceptQty: number;
    brandCd: string;
    brandNm: string;

	remark: string;

	inserted: boolean,
	isModified: boolean,
	disabled: boolean,

    codeEntity?: any | null;
}

/**
 * 작업지시 목록의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultKSK2010_R01Dto: KSK2010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

    productOrderNo:  '',
    compCd: '',
    compNm: '',

    orderDt: formatDate(getFutureWeekdayExceptTodayAndTomorrow()),
    orderType: '',
    orderTypeNm: '',
    workplaceCd: '',
    workplaceNm: '',
    jobTeam: '',
    jobTeamNm: '',
    workProcess: '',
    itemCd: '',
    itemNm: '',
    itemSpec: '',
    itemUnit: '',
    orderQty: 0,
    orderEmp: '',
    orderEmpNm: '',
    productPlanNo: '',
    resultQty: 0,
    basOrderType: '',
    basOrderNo: '',
    basOrderItemNo: '',
    closeTag: "N",
    remark: '',

	inserted: false,
	isModified: false,
	disabled: false,
	
    codeEntity: null,

    badQty: 0,
    acceptQty: 0,
    brandCd: '',
    brandNm: '',
};
